import { Box } from 'src/theme'

export default function CriticalError () {
  return (
    <Box p={6}>
      Campaign not found
    </Box>
  )
}
